import React from 'react';

const PerfilHeader = ({ perfil, valoracionPromedio = '0,0', children, onVerAgenda, videoPromo, onSeguir, estasSiguiendo, contadorSeguidores, onValoracionClick }) => {
const isAdminAccess= false;
const isOwnerAccess=false;
console.log('Perfil data:', perfil);
const prefix = `${process.env.REACT_APP_UPLOADS_URL}/`;
return (
  <>
    {/* Secci�n de imagen con nombre debajo */}
    <div className="profile-image-container">
      {/* Badge de perfil verificado */}
      {perfil.verificada && (
        <div className="verify-badge">
          <div className="verify-icon">
            <i className="fas fa-check"></i>
          </div>
          {perfil.tipo || 'Perfil Verificado'}
        </div>
      )}
      
      <div className={`profile-name-overlay ${(isAdminAccess || isOwnerAccess) ? 'editable' : ''}`}>
        <span>{perfil.nombre}</span>
      </div>

      {/* Imagen de perfil */}
      <div className="profile-image">
        <img 
          src={perfil.fotos ? `${prefix}ID_${perfil.id}/${perfil.fotos}?v=${perfil.id}`: `${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
          alt={perfil.nombre}
          className="profile-image-display"
          draggable={false}
          onContextMenu={(e) => e.preventDefault()}
        />
      </div>

      {/* Contenedor para los botones */}
      <div className="profile-action-buttons">
        <button className="ver-agenda-btn" onClick={onVerAgenda}>
          <i className="fas fa-calendar-check"></i>
          Ver agenda disponible
        </button>
      </div>
    </div>
    <div className="profile-info">
      {/* Tags */}
      <div className="profile-tags">
<div className="followers-tag">
          <div className="followers-icon">
            <i className="fas fa-users"></i>
          </div>
          Seguidores {(contadorSeguidores || 0).toLocaleString('es-CL')}
        </div>
<div
          className={`seguir-tag ${estasSiguiendo ? 'seguir-tag-activo' : ''}`}
          onClick={onSeguir}
          style={{ cursor: 'pointer' }}
        >
          <div className="seguir-icon">
            <i className={`fas ${estasSiguiendo ? 'fa-user-check' : 'fa-user-plus'}`}></i>
          </div>
          {estasSiguiendo ? 'Siguiendo ✓' : 'Seguir'}
        </div>
<div
          className={`valoracion-tag ${
            parseFloat(valoracionPromedio.replace(',', '.')) >= 4.0 
              ? 'valoracion-verde' 
              : 'valoracion-roja'
          }`}
          onClick={onValoracionClick}
          style={{ cursor: 'pointer' }}
        >
          <div className="valoracion-icon">
            <i className="fas fa-book"></i>
          </div>
          Valoracion Nota: {valoracionPromedio}
        </div>
      </div>
      <div className="profile-attributes">
        <div className={`attribute ${(isAdminAccess || isOwnerAccess) ? 'editable' : ''}`}>
          <span>{perfil.edad} años</span>
        </div>
        {/* Tag Mujer/Hombre/Travesti */}
        <div className={`mujer-tag ${(isAdminAccess || isOwnerAccess) ? 'editable' : ''}`}>
          <div className="mujer-icon">
            <i className={`fas ${
              perfil.genero === 'Hombre' ? 'fa-male' :
              perfil.genero === 'Travesti' ? 'fa-transgender' :
              'fa-female'
            }`}></i>
          </div>
            <span>{perfil.genero || 'Mujer'}</span>
          </div>
        {/* Tag de Categoría movido aquí */}
        <div className={`scort-tag ${(isAdminAccess || isOwnerAccess) ? 'editable' : ''}`}>
          <div className="scort-icon">
            <i className="fas fa-star"></i>
          </div>
          <span>{perfil.categoria || 'Scort'}</span>
        </div>
      </div>
      
      {/* PANEL CREADOR */}
      {children}
      
      {/* Contenedor para tarifa y video */}
      <div className="tarifa-video-container">
        {/* Secci�n de tarifas separada */}
        <div className="tarifa">
          <div className={`profile-tarifa ${(isAdminAccess || isOwnerAccess) ? 'editable' : ''}`}>
            <div className="tarifa-title">VALOR:</div>
            <div className="tarifa-item">
              <div className="tarifa-tipo">1 HORA</div>
<div className="tarifa-precio">
  {perfil.precio_una_hora && !isNaN(Number(String(perfil.precio_una_hora).replace(/\./g, '')))
    ? `$${Number(String(perfil.precio_una_hora).replace(/\./g, '')).toLocaleString('es-CL')}`
    : (perfil.precio_una_hora || '0')}
</div>
            </div>
            <div className="tarifa-item">
              <div className="tarifa-tipo">MEDIA HORA</div>
<div className="tarifa-precio">
  {perfil.precio_media_hora && !isNaN(Number(String(perfil.precio_media_hora).replace(/\./g, '')))
    ? `$${Number(String(perfil.precio_media_hora).replace(/\./g, '')).toLocaleString('es-CL')}`
    : (perfil.precio_media_hora || 'No disponible')}
</div>
            </div>
          </div>
        </div>
      
        {/* ? AQU� VA EL COMPONENTE DE VIDEO PROMO ? */}
        {videoPromo}
      </div>
    </div>
  </> 
);
}
export default PerfilHeader;